export const gridRowIdHelper = (params, rowId) => {
  const id = params.data[rowId];
  return String(id);
};